import styles from "./TeamCreate.module.css";
import { useDispatch, useSelector } from 'react-redux';
import { selectUser } from '../redux/slices/userSlice';
import {
  selectTeams,
  setCreateForm,
  setTeamsError,
  clearTeamsError,
  teamCreate,
  clearCreateResult,
  setTeamSelected,
} from '../redux/slices/teamsSlice';
import { useEffect } from 'react';
import { useToaster } from '../components/Toaster';
import { useNavigate } from 'react-router-dom';

export default function TeamCreate() {
  const user = useSelector(selectUser);
  const teams = useSelector(selectTeams);
  const dispatch = useDispatch();
  const { push } = useToaster();
  const navigate = useNavigate();

  const handleInputChange = (e) => {
    dispatch(
      setCreateForm({
        ...teams.create_form,
        [e.target.name]: e.target.value,
      })
    );
  };

  const handleSubmit = () => {
    if (!(teams?.create_form?.name)) {
      dispatch(setTeamsError({ msg: '請輸入團隊名稱！' }));
      return;
    }

    dispatch(teamCreate({
      account_token: user?.data?.token,
      name: teams?.create_form?.name,
    }));
  };

  useEffect(() => {
    const e = teams.error;
    const msg = (e && (e.msg || e.message)) || '';

    if (msg) {
      push({ title: '發生錯誤', message: msg, variant: 'danger' });
      dispatch(clearTeamsError());
    }
  }, [teams.error, push, dispatch]);

  useEffect(() => {
    if (teams?.create_result?.token ?? '') {
      push({ title: '建立成功', message: '建立成功', variant: 'success' });
      dispatch(setCreateForm({name: ''}));
      dispatch(clearCreateResult());
      dispatch(setTeamSelected(teams?.create_result?.token));
      navigate('/', { replace: true });
    }
  }, [teams.create_result, push, dispatch]);

  return (
    <>
      <section className={styles.teamsWrap}>
        <div className={`${styles.panel} mt-2`}>
          <div className={`px-2 px-md-5 py-2 py-md-5 ${styles.content} row g-4`}>
            <div className="col-12">
              <div className={`p-md-4 ${styles.block}`}>
                <h4 className={styles.sectionTitle}>
                  <i className="bi bi-people-fill me-2" />
                  建立新團隊
                </h4>

                <form
                  className={styles.form}
                  onSubmit={(e) => {
                    e.preventDefault();
                    handleSubmit();
                  }}
                >
                  {(teams?.no_teams == true) && (
                    <div className={`${styles.noTeam} mb-2`}>
                      <i className="bi bi-info-circle me-2" aria-hidden="true"></i>
                      由於您尚未屬於任何團隊，請先建立一個團隊！
                    </div>
                  )}

                  <div className="mb-3">
                    <label
                      htmlFor="team-create_teamName"
                      className={`${styles.fieldLabel} form-label`}
                    >
                      <span className={styles.labelDot} aria-hidden="true" />
                      團隊名稱 <span className="text-danger">*</span>
                    </label>

                    <input
                      type="text"
                      className={`form-control ${styles.input}`}
                      id="team-create_teamName"
                      placeholder="輸入團隊名稱"
                      name="name"
                      value={teams?.create_form?.name ?? ''}
                      onChange={handleInputChange}
                      maxLength={20}
                    />

                    <div className={styles.helpRow}>
                      <small className={styles.helpText}>
                        最多 20 字。請使用容易辨識的名稱。7 天內只允許建立 2 個團隊。
                      </small>
                      <small className={styles.charCount}>
                        {(teams?.create_form?.name ?? '').length}/20
                      </small>
                    </div>
                  </div>

                  <div className={styles.actions}>
                    <button
                      type="button"
                      className={styles.btnSave}
                      onClick={handleSubmit}
                    >
                      <i className="bi bi-send-check me-1" />
                      送出
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}